import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { fetchPrompts }   from '../api/promptApi'
import PromptList         from '../components/prompts/PromptList'
import PromptEditPanel    from '../components/prompts/PromptEditPanel'
import { SkeletonList, SkeletonText } from '../../shared/ui'

export default function PromptEditor() {
  const { projectId }          = useParams()
  const [prompts,  setPrompts]  = useState([])
  const [selected, setSelected] = useState(null)
  const [loading,  setLoading]  = useState(true)
  const [error,    setError]    = useState(null)

  const hasProjectOverride = selected
  ? prompts.some(p =>
      p.project_id != null &&
      p.prompt_type === selected.prompt_type &&
      p.scope_key === selected.scope_key &&
      p.artifact_type === selected.artifact_type
    )
  : false

  useEffect(() => {
    loadPrompts()
  }, [projectId])

  async function loadPrompts() {
    setLoading(true)
    try {
      const data = await fetchPrompts(projectId ? Number(projectId) : null)
      setPrompts(data)
    } catch {
      setError('Failed to load prompts.')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="flex h-full min-h-0">
        <div className="w-56 flex-shrink-0 border-r border-gray-200 bg-white p-3">
          <SkeletonList rows={6} />
        </div>
        <div className="flex-1 p-6">
          <SkeletonText lines={6} />
        </div>
      </div>
    )
  }

  if (error) {
    return <p className="text-sm text-red-500 text-center py-12">{error}</p>
  }

  return (
    <div className="flex h-full min-h-0">
      <PromptList
        prompts    ={prompts}
        selectedId ={selected?.id}
        onSelect   ={setSelected}
      />
      <PromptEditPanel
        prompt    ={selected}
        projectId ={projectId ? Number(projectId) : null}
        hasProjectOverride={hasProjectOverride}
        onSaved   ={loadPrompts}
      />
    </div>
  )
}
